/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Button from "components/Button";
import Checkbox from "components/CheckBox";
import TextField from "components/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Select from "components/Select";
import {
  ssaActiveWearUSProducts,
  ssActiveWearCAProducts,
  editPrintProvidersInformation,
} from "actions/products";
import { printProvidersData } from "pages/edit-products/data";
import {
  Container,
  ProductInformation,
  SelectCategories,
  Update,
  Wrapper,
  StockPartner,
  StockPartnerInput,
  SubHeading,
} from "styles/pages/edit-products/editProductInformation";

const options = ["S&S ACTIVE WEAR", "ALPHA BRODER", "SANMAR", "NONE"];

const EditPrintProviderInformation = ({
  product = { Product: {} },
  updateProductPrintProviders,
}) => {
  const dispatch = useDispatch();
  const products = useSelector((state) => state?.products?.data);
  const [printProviders, setPrintProviders] = useState(null);
  const [selectedProviderNames, setSelectedProviderNames] = useState([]);

  useEffect(() => {
    if (!printProviders) {
      let data = [];
      let selectedPP = [];
      for (let i = 0; i < printProvidersData.length; i++) {
        let providers = printProvidersData[i];
        for (let j = 0; j < product?.PrintProviders?.length; j++) {
          if (
            printProvidersData[i]?.ProviderName ===
            product?.PrintProviders[j]?.ProviderName
          ) {
            providers = product?.PrintProviders[j];
            selectedPP.push(product?.PrintProviders[j]?.ProviderName);
            break;
          }
        }
        data.push(providers);
      }
      setPrintProviders(data);
      setSelectedProviderNames(selectedPP);
    }
  }, [
    product,
    printProviders,
    setPrintProviders,
    printProvidersData,
    setSelectedProviderNames,
  ]);

  const disabled = () => {
    if (!selectedProviderNames || !selectedProviderNames?.length) {
      return true;
    }
    for (let i = 0; i < selectedProviderNames.length; i++) {
      for (let j = 0; j < printProviders?.length; j++) {
        const tempProviderName = printProviders[j]?.ProviderName;
        if (selectedProviderNames[i] === tempProviderName) {
          for (let k = 0; k < printProviders[j].ShippingCosts?.length; k++) {
            const shippingCost = printProviders[j].ShippingCosts[k];
            const {
              Title,
              PrimaryCost,
              SecondaryCost,
              ShippingTimeMinInDays,
              ShippingTimeMaxInDays,
            } = shippingCost;

            if (
              !Title ||
              PrimaryCost < 0 ||
              SecondaryCost < 0 ||
              ShippingTimeMaxInDays < 0 ||
              ShippingTimeMinInDays < 0
            ) {
              return true;
            }
          }
        }
      }
    }

    return false;
  };

  return (
    <Container>
      <ProductInformation>
        <h3>Print Providers</h3>
        <div></div>
      </ProductInformation>

      <SelectCategories>
        <Grid container spacing={1}>
          {printProviders?.map((p, i) => {
            const providerName = p?.ProviderName;
            return (
              <Grid key={`ProviderName${i}`} item xs={12} sm={12} md={12}>
                <Checkbox
                  label={p?.ProviderName}
                  checked={selectedProviderNames.includes(p?.ProviderName)}
                  onChange={(v) => {
                    if (v) {
                      setSelectedProviderNames([
                        ...selectedProviderNames,
                        p?.ProviderName,
                      ]);
                    } else {
                      setSelectedProviderNames(
                        selectedProviderNames?.filter(
                          (s) => s != p?.ProviderName
                        )
                      );
                    }
                  }}
                />
                {p?.ShippingCosts?.map((s, j) => (
                  <Wrapper key={`ShippingCosts${j}`}>
                    <b style={{ margin: "10px 20px 20px 0" }}>
                      {s?.ShippingDestination}
                    </b>
                    <TextField
                      label="Title"
                      size="small"
                      value={s?.Title}
                      disabled={
                        !selectedProviderNames.includes(p?.ProviderName)
                      }
                      onChange={(value) => {
                        setPrintProviders(
                          printProviders?.map((p, index) => {
                            if (index !== i) {
                              return p;
                            }

                            return {
                              ...p,
                              ShippingCosts: p?.ShippingCosts.map((sc, k) => {
                                if (k !== j) {
                                  return sc;
                                }
                                return {
                                  ...sc,
                                  Title: value,
                                };
                              }),
                            };
                          })
                        );
                      }}
                    />
                    <TextField
                      label="Primary Cost"
                      size="small"
                      value={s?.PrimaryCost}
                      type="number"
                      disabled={
                        !selectedProviderNames.includes(p?.ProviderName)
                      }
                      onChange={(value) => {
                        setPrintProviders(
                          printProviders?.map((p, index) => {
                            if (index !== i) {
                              return p;
                            }

                            return {
                              ...p,
                              ShippingCosts: p?.ShippingCosts.map((sc, k) => {
                                if (k !== j) {
                                  return sc;
                                }
                                return {
                                  ...sc,
                                  PrimaryCost: Number(value),
                                };
                              }),
                            };
                          })
                        );
                      }}
                    />
                    <TextField
                      label="Secondary Cost"
                      size="small"
                      value={s?.SecondaryCost}
                      type="number"
                      disabled={
                        !selectedProviderNames.includes(p?.ProviderName)
                      }
                      onChange={(value) => {
                        setPrintProviders(
                          printProviders?.map((p, index) => {
                            if (index !== i) {
                              return p;
                            }

                            return {
                              ...p,
                              ShippingCosts: p?.ShippingCosts.map((sc, k) => {
                                if (k !== j) {
                                  return sc;
                                }
                                return {
                                  ...sc,
                                  SecondaryCost: Number(value),
                                };
                              }),
                            };
                          })
                        );
                      }}
                    />
                    <TextField
                      label="Ship Min Days"
                      size="small"
                      value={s?.ShippingTimeMinInDays}
                      type="number"
                      disabled={
                        !selectedProviderNames.includes(p?.ProviderName)
                      }
                      onChange={(value) => {
                        setPrintProviders(
                          printProviders?.map((p, index) => {
                            if (index !== i) {
                              return p;
                            }

                            return {
                              ...p,
                              ShippingCosts: p?.ShippingCosts.map((sc, k) => {
                                if (k !== j) {
                                  return sc;
                                }
                                return {
                                  ...sc,
                                  ShippingTimeMinInDays: Number(value),
                                };
                              }),
                            };
                          })
                        );
                      }}
                    />
                    <TextField
                      label="Ship Max Days"
                      size="small"
                      value={s?.ShippingTimeMaxInDays}
                      type="number"
                      disabled={
                        !selectedProviderNames.includes(p?.ProviderName)
                      }
                      onChange={(value) => {
                        setPrintProviders(
                          printProviders?.map((p, index) => {
                            if (index !== i) {
                              return p;
                            }

                            return {
                              ...p,
                              ShippingCosts: p?.ShippingCosts.map((sc, k) => {
                                if (k !== j) {
                                  return sc;
                                }
                                return {
                                  ...sc,
                                  ShippingTimeMaxInDays: Number(value),
                                };
                              }),
                            };
                          })
                        );
                      }}
                    />
                  </Wrapper>
                ))}

                <StockPartner>Stock Partner</StockPartner>
                <StockPartnerInput>
                  <Select
                    label="Select Supplier"
                    options={options}
                    disabled={!selectedProviderNames.includes(p?.ProviderName)}
                    value={p?.supplier}
                    onChange={async (supplier) => {
                      if (supplier === options[0]) {
                        const data =
                          p?.ProviderName === "CA"
                            ? await dispatch(ssActiveWearCAProducts())
                            : await dispatch(ssaActiveWearUSProducts());

                        setPrintProviders(
                          printProviders?.map((p, index) => {
                            if (index !== i) {
                              return p;
                            }
                            return {
                              ...p,
                              ssInventoryList: data,
                              supplier,
                              productCode: "",
                            };
                          })
                        );
                      } else {
                        setPrintProviders(
                          printProviders?.map((p, index) => {
                            if (index !== i) {
                              return p;
                            }
                            return {
                              ...p,
                              ssInventoryList: undefined,
                              supplier,
                              productCode: "",
                            };
                          })
                        );
                      }
                    }}
                  />

                  {p?.ssInventoryList && (
                    <Autocomplete
                      options={p?.ssInventoryList}
                      getOptionLabel={(option) =>
                        `${option?.brandName}-${option?.styleName}`
                      }
                      onChange={(event, newValue) => {
                        setPrintProviders(
                          printProviders?.map((p, index) => {
                            if (index !== i) {
                              return p;
                            }
                            return {
                              ...p,
                              selectedSSInventory: newValue,
                              productCode: newValue?.styleID,
                            };
                          })
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Inventory Product"
                        />
                      )}
                    />
                  )}
                  {(p?.supplier === options[1] ||
                    p?.supplier === options[2]) && (
                    <TextField
                      label="Enter Product Code / Number"
                      value={p?.productCode}
                      onChange={(v) =>
                        setPrintProviders(
                          printProviders?.map((p, index) => {
                            if (index !== i) {
                              return p;
                            }
                            return {
                              ...p,
                              productCode: v?.toLowerCase(),
                              selectedSSInventory: undefined,
                            };
                          })
                        )
                      }
                    />
                  )}
                </StockPartnerInput>

                {providerName !== "CA" && providerName !== "US" && (
                  <>
                    <SubHeading>BOT Mark Up Percentage</SubHeading>
                    <StockPartnerInput>
                      <TextField
                        label="Company Name"
                        value={p?.companyName || ""}
                        onChange={(companyName) =>
                          setPrintProviders(
                            printProviders?.map((q, index) => {
                              if (index !== i) {
                                return q;
                              }
                              return {
                                ...q,
                                companyName,
                              };
                            })
                          )
                        }
                      />

                      <TextField
                        label="Mark Up Percentage"
                        type="number"
                        value={p?.markUpPercentage || 0}
                        onChange={(markUpPercentage) =>
                          setPrintProviders(
                            printProviders?.map((q, index) => {
                              if (index !== i) {
                                return q;
                              }
                              return {
                                ...q,
                                markUpPercentage: Number(markUpPercentage),
                              };
                            })
                          )
                        }
                      />
                    </StockPartnerInput>
                  </>
                )}
              </Grid>
            );
          })}
        </Grid>
      </SelectCategories>

      <Update>
        <Button
          title="Update Product Prices"
          style={{ marginRight: "10px", display: "none" }}
          onClick={async () => {
            for (let i = 0; i < products.length; i++) {
              const p = products[i];
              const printProviders = p?.PrintProviders;
              const payload = {
                ID: p?.Product?.ID,
                printProvidersData: printProviders.map((q) => ({
                  ...q,
                  ShippingCosts: q?.ShippingCosts?.map((s) => ({
                    ...s,
                    PrimaryCost: s?.PrimaryCost + 4,
                    Title:
                      q.ProviderName === "US"
                        ? "USPS First Class Mail"
                        : s?.Title,
                  })),
                })),
              };

              await dispatch(editPrintProvidersInformation(payload, false));
            }
          }}
        />

        <Button
          title="Update"
          disabled={disabled()}
          onClick={() => {
            const q = printProviders.filter((p) =>
              selectedProviderNames.includes(p?.ProviderName)
            );

            const payload = {
              ID: product?.Product?.ID,
              printProvidersData: q.map((p) => ({
                ...p,
                ssInventoryList: undefined,
                supplier: p?.supplier === options[3] ? "" : p?.supplier,
              })),
            };

            updateProductPrintProviders(payload);
          }}
        />
      </Update>
    </Container>
  );
};

export default EditPrintProviderInformation;
